
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g2px6Wjx_455bNqkROa56lQ7jh3Q1AeQ501QIWF_VFObC4Meta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexcyNs_cxTun_snvVik1w1bVuXwr__45fd2a3yACLxIbrN0Meta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchcalR48UYc6YuudTDbhV2CD_45pQq42m_45wfTa7qNzp_VTQMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index4svurxubIhqs4f55V_45NrILlr9lVtxW4GXs9oKw9ntDwMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_939Oo_9MdQCrh1tZwbu8N4BtLwjFejZEsPRcvYxMd_45qysMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexrGvA06GC6c82ZfRqb31soK9oE334xcldmkagCJy3_45okMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93eTbm3L1xY6yoaSx7SBBsVxzpVAGjR_45w_45Rh_iqUxoUtsMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexgai04YIGERihnT2BdvtEbTm6GFT1Ff_ICvZonWc3dzkMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93VoMOPOeC6_45ujy78apr8Dv07IYeL_45_45ULu_45OWMlteXtZ4Meta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmvUWPDPGaTsPqkrIeiVgdulnX36HRWq1kybRSJIN5okMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexqZxsPLbzTOtg5a_45CrBoXN_453U0pkao66EuLLoi5chEFMMeta } from "/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexrGvA06GC6c82ZfRqb31soK9oE334xcldmkagCJy3_45okMeta || {},
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexgai04YIGERihnT2BdvtEbTm6GFT1Ff_ICvZonWc3dzkMeta || {},
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmvUWPDPGaTsPqkrIeiVgdulnX36HRWq1kybRSJIN5okMeta || {},
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexqZxsPLbzTOtg5a_45CrBoXN_453U0pkao66EuLLoi5chEFMMeta || {},
    component: () => import("/codebuild/output/src2945180330/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]